import type { FaireProductEntity } from "../../entity_types/product";

export const p_pucv434fsh: FaireProductEntity = {
  token: "p_pucv434fsh",
  type: "product",
  name: "LONG SLEEVE CREW NECK SWEATER LIGHTWEIGHT CARDIGAN",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/989f03850f5a43043e7761f3e68189b96390df68b2149b060a42de625404b378.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff803428e3d86b173b04e1ef937e36bbd999404481679d7f9b986963d19f23b8.jpeg",
    "https://cdn.faire.com/fastly/2eb3dea7907edb7ee7a296c58c7062ec4eb1b958e043888cddde058abb6a14e2.jpeg",
    "https://cdn.faire.com/fastly/6226785066b10f32284e8e65a7cf508c1b2465584f2b7426d2cf35c83b0fd641.jpeg",
    "https://cdn.faire.com/fastly/623ef98261843a8ce8e1fcdc3fdfd5a4f7423aaa324060de6850880772db43d2.jpeg",
    "https://cdn.faire.com/fastly/14aa8c95d34c95beb1cbc813d4824f106f4b3a5398d01df00a514a57f35a9248.jpeg",
    "https://cdn.faire.com/fastly/17f7b41f272cd0dd9930b17d8ecf0806c8dd0364c27df9f84edf1da2f0edf953.jpeg",
    "https://cdn.faire.com/fastly/f19e7c6b576689eb18a2214b73ce760805b0dcf4676e57ee03dc2a9db4d81bac.jpeg",
    "https://cdn.faire.com/fastly/ea9061dd94592d3cb1120bb8290dab31705241a0fd5270dbe9d6eaf1eb35b9a1.jpeg",
    "https://cdn.faire.com/fastly/406bdbef3839fa4183bc3ff9627757807613d9c78136ab51cd18d9b1eabf10c6.jpeg",
    "https://cdn.faire.com/fastly/9f7312f8ecfc072eecae9381142b8323e6192a2658c9ac084840286dc33e419c.jpeg",
    "https://cdn.faire.com/fastly/8a8c076abdb0b488d3355400c7e18f3bc7af59cad28eff9eb30a40d522982620.jpeg",
    "https://cdn.faire.com/fastly/43e07099ba5dbbf0def6b1fe68f60e4e4efc41e6696ec257646332b57e540bf9.jpeg",
    "https://cdn.faire.com/fastly/191ad9d9b5de1069666078971e84c202ee3a6bc75a73757d0e8db999d4c29ee7.jpeg",
    "https://cdn.faire.com/fastly/b3b66108d6e351e9d4374a035a5bd678a249a2371a35b001785fbbfde20f3f2f.jpeg",
    "https://cdn.faire.com/fastly/61887e8179319b8a5654ea341d79e260adfee0260e316f7150f934d5dfe717aa.jpeg",
    "https://cdn.faire.com/fastly/f5408f2d781335f08a7dcaa419f61aebadab9453f5134025d1632ccc1935ee39.jpeg",
    "https://cdn.faire.com/fastly/532eab786dc2dedbf75da8574440620eb3f7bac06be0a667c39d873d9bee7508.jpeg",
    "https://cdn.faire.com/fastly/69474eac29f5d86347810a16e4480bc5172962ddc7337cb7742218b6e98bb10a.jpeg",
    "https://cdn.faire.com/fastly/9bc7e99ff1e2eaad915d636ae25d3ca2cba70e60f90c62564fcfea29306321d1.jpeg",
    "https://cdn.faire.com/fastly/54c90323c9227bf292673125ca17a5e5be22f9f2fe0a21dc2e8d3f9a8222fa21.jpeg",
    "https://cdn.faire.com/fastly/0b58a44c4050108b2698c487a7849e63fde0ebad34ffd07beada3bc8179358d2.jpeg",
    "https://cdn.faire.com/fastly/4e6f45d32c17c50f7599324fd64c9b974644a2800869b0a4c3f8c8b5887b498c.jpeg",
    "https://cdn.faire.com/fastly/e0375a1683debac02c5db86a74136716f791eead2a1f57374c2e7bc837b83f8d.jpeg",
    "https://cdn.faire.com/fastly/a927589ce2082809490a42e84c9b73143c64e3ffbc66e1d64df3998d38387faf.jpeg",
    "https://cdn.faire.com/fastly/40db7c48a2ee8ec118750ed4554ceb2d4a89c901617878b80ad2948c65a566b3.jpeg",
    "https://cdn.faire.com/fastly/faf110148d337228f264d15bb1dc267976ace6ec7746ba731c34030e190e2281.jpeg",
    "https://cdn.faire.com/fastly/0881fa6c8411fbda4c010451fbd3a519e28245969cc6567d0fad454dddc86327.jpeg",
    "https://cdn.faire.com/fastly/14e02de0bbcc8e0e17c550d0d3c66b1b5d4ab45dedc712029d916af910e80a6f.jpeg",
    "https://cdn.faire.com/fastly/38322fd40508a6fa7a0638f0242ab889e1918bf875ca3a71123e31476bd44e3f.jpeg",
    "https://cdn.faire.com/fastly/a126db9b2be86180530f772b9e936ea92e172742a0ecae9f1aae05a25933e87a.jpeg",
    "https://cdn.faire.com/fastly/673bd3cea4dffe2a9795e661260c0d40d063b1c56f2068b407523494d79e364b.jpeg",
    "https://cdn.faire.com/fastly/dea14f4ba934c911e30417c24d34fd67d1bb2176240e30480f09197d27be4429.jpeg",
    "https://cdn.faire.com/fastly/e1d366d9160cfaf8298af2fb70ec6a6582c9615d232091a748218c8e123276d3.jpeg",
    "https://cdn.faire.com/fastly/6ad536796afb2338fc511bb09c0f747831d6be458b26c7a26d9668d3b6ccf340.jpeg",
    "https://cdn.faire.com/fastly/443688aa84ace29056687036effc81539d5972aebe5212ddfeec15ef6820e724.jpeg",
    "https://cdn.faire.com/fastly/9f2b3bdd3fda825e76c8db9e66d101a6d8ba191d769c16a775202382caee4d21.jpeg",
    "https://cdn.faire.com/fastly/15e9af052ab6caf7c2b6c03d812027270a2b5eba65101bf6ac8b44afdd113c59.jpeg",
    "https://cdn.faire.com/fastly/a4ef3e0b2465a4ae19efbfb1918805e09cd895c4f7d3621f7d669e8f1b35e9d1.jpeg",
    "https://cdn.faire.com/fastly/00e1927b32783df0432d3b65b6958ee1ee807fdf1d04b85a9792727cae2719ed.jpeg",
    "https://cdn.faire.com/fastly/c4d2b7106b4e2f9905a41057ae5aeed15c1d1db3dda141841e010275f4fdf19c.jpeg",
    "https://cdn.faire.com/fastly/f89fdfe59c614d4a15e6a365b9b5d7c1cceb861193fd5e6b6fdca3d266a4180d.jpeg",
    "https://cdn.faire.com/fastly/8e863b35f959ae7c58ce4c22de0c441d35544d1621a14cbd8e23b5f1d9c6c2a0.jpeg",
    "https://cdn.faire.com/fastly/db4bd68baaaf2b4262f811b9b2d742b0c4d507848e001269cbb21368fe321baf.jpeg",
    "https://cdn.faire.com/fastly/ba3ce1ed762873596ad82982ae461d8f1e685a0d9543591e9a52c07fc31deffd.jpeg",
    "https://cdn.faire.com/fastly/8b4506402c051e8368370192b41533089668adecc76c1c0e17f1b8aec63db30f.jpeg",
    "https://cdn.faire.com/fastly/b6a2cf9c347377805944d73d408bc07e3f02dd70870d89a6b30297f29c7e671f.jpeg",
  ],
  priceDollars: 156,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32A\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 312,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:12.689Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
